import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '~/core/core.module';

export interface AuthenticationRO {
  username: string;
  emailAddress: string;
  givenName: string;
  familyName: string;
  startPage: NavigationItemRO;
  userId: string;
}

export interface NavigationItemRO {
  name: string;
  url: string;
  routeType: string;
  target: 'FRONTENDROUTE' | 'SUITEROUTE';
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private httpClient: HttpClient) {}

  checkUser(): Observable<AuthenticationRO> {
    return this.httpClient.get<AuthenticationRO>(`${environment.BACKEND_URL}/checkuser`);
  }
}
